import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createABESubmittal, updateABEQuotation } from 'src/_helpers/api';

const name = 'abeSubmittals';

const initialState = {
  abeSubmittals: [],
  error: null,
};

// Ajouter un ABE Submittal
const addABESubmittalAsync = createAsyncThunk(`${name}/add-abe-submittal`, async (submittalData, { rejectWithValue }) => {
  try {
    const response = await createABESubmittal(submittalData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSubmittalAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const updateABESubmittalAsync = createAsyncThunk(`${name}/update-abe-submittal`, async (submittalData) => {
//  console.log('🚀 ~ submittalData:', submittalData)
  return await updateABEQuotation(submittalData)
})

const abeSubmittalSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.abeSubmittals = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addABESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addABESubmittalAsync.fulfilled, (state, action) => {
        state.abeSubmittals.push(action.payload);
      })
      .addCase(addABESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(updateABESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(updateABESubmittalAsync.fulfilled, (state, action) => {
        const index = state.abeSubmittals.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.abeSubmittals[index] = action.payload;
      })
      .addCase(updateABESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const abeSubmittalActions = {
  ...abeSubmittalSlice.actions,
  addABESubmittalAsync,
  updateABESubmittalAsync,
};

export const abeSubmittalsReducer = abeSubmittalSlice.reducer;
